module.exports = __webpack_public_path__ + "assets/85fd6f2293f5c57fcbeff9be5d782ba5.png";